module.exports = __webpack_public_path__ + "assets/img/bg3.d5815ae2.jpg";